module.exports = __webpack_public_path__ + "static/media/syncWhatsapp_step1_en.0a7755c1.jpg";